import React from "react";
import SimpleTable from "../../../common/tables/SimpleTable";
import {LinkCopyPopup} from "../../../common/linkCopyPopup/LinkCopyPopup";
import {getRusDateString} from "../../../../utils/dateUtils";
import useResizeObserver from "../../../../hooks/useResizeObserver";
import NdsToolsPopover from "./NdsToolsPopover";
import {useDispatch, useSelector} from "react-redux";
import {deleteNdsItem, loadNdsItems} from "../../../../actions/ndsActions";
import ActionPopover from "../../../common/popovers/ActionPopover";

export default function NdsToolsTable({}) {

    const dispatch = useDispatch();
    const tableData = useSelector(state => state.ndsReducer.ndsItems);

    const deleteItem = (id) => {
        dispatch(deleteNdsItem(id, () => dispatch(loadNdsItems())));
    }

    const tableColumns = () => {
        return [
            {
                name: "Страна",
                key: "countryId",
                getBodyCellValue: item => item?.countryName,
                headerCellStyle: {minWidth: "200px", maxWidth: "300px"},
                bodyCellStyle: {textAlign: "left", maxWidth: "300px"},
            },
            {
                name: "Ставка НДС, %",
                key: "value",
                getBodyCellValue: item => item?.value ? item.value : "",
                headerCellStyle: {minWidth: "50px", textAlign: "left"},
                bodyCellStyle: {textAlign: "left"},
            },
            {
                name: "Дата начала действия",
                key: "fromDate",
                getBodyCellValue: item =>  item?.fromDate ? getRusDateString(new Date(item.fromDate)) : "",
                headerCellStyle: {width: "240px", minWidth: "240px", textAlign: "left"},
                bodyCellStyle: {textAlign: "left"},
            },
            {
                name: <NdsToolsPopover button={<i className="ti ti-plus td-save" style={{cursor: "pointer", fontSize: "18px"}}
                                                     title="Заменить оффер"/>} item={null} loadTableData={() => {}}/>,
                key: "actions",
                getBodyCellValue: (item) =>  <div className="form-row">
                    <NdsToolsPopover button={<i className="ti ti-pencil td-save" style={{cursor: "pointer", fontSize: "18px"}}
                                                title="Заменить оффер"/>} item={item} loadTableData={() => {}}/>
                    <ActionPopover
                        button={<i className="ti ti-trash  td-save"  style={{cursor: "pointer", fontSize: "18px"}}/>}
                        popoverLocation='top'
                        label={"Удалить ставку НДС?"}
                        handleSubmit={() => deleteItem(item.id)}
                    />
                </div>,
                bodyCellStyle: {minWidth: "70px", width: "70px"},
                headerCellStyle: {minWidth: "70px", textAlign: "right"},
                isSortingDisabled: true,
            },
        ]
    };


    const height = useResizeObserver(document.getElementById("scrollable")).height - 5;

    return (
        <div className="responsive-block statistic_table_wrapper" id="fullWidth" onScroll={() =>{}} style={{height: height + "px"}}>
           <SimpleTable tableClassName="table table-bordered nowrap statistic_table sticky-header sticky-action sticky-footer userselecttext"
                               columns={tableColumns()}  data={tableData} bodyRowKey="id" />
        </div>
    )
};